/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SchemaDefinition } from '../../openapi/v3/models/Oas30SchemaDefinition';
import { AddSchemaDefinitionCommand } from './AddSchemaDefinitionCommand';
import { Oas30Components } from '../../openapi/v3/models/Oas30Components';
import { Node } from '../../core/models/Node';

/**
 * OAI version 3.0.x impl.
 * @author eric.wittmann@gmail.com
 * @extends AddSchemaDefinitionCommand
 * @class
 */
export class AddSchemaDefinitionCommand_30 extends AddSchemaDefinitionCommand {
    public _nullComponents : boolean;

    public constructor(definitionName? : any, from? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super(definitionName, from);
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else if(((typeof definitionName === 'string') || definitionName === null) && from === undefined) {
            let __args = arguments;
            super(definitionName);
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else if(definitionName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#defExists(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {boolean}
     */
    defExists(document : OasDocument) : boolean {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            return false;
        }
        return !this.isNullOrUndefined(doc30.components.getSchemaDefinition(this._newDefinitionName));
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#prepareDocumentForDef(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    prepareDocumentForDef(document : OasDocument) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            doc30.components = doc30.createComponents();
            this._nullComponents = true;
        } else {
            this._nullComponents = false;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#createSchemaDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {OasSchema}
     */
    createSchemaDefinition(document : OasDocument) : OasSchema {
        let doc30 : Oas30Document = <Oas30Document>document;
        let definition : Oas30SchemaDefinition = doc30.components.createSchemaDefinition(this._newDefinitionName);
        Library.readNode(this._newDefinitionObj, definition);
        return definition;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#addDefinition(io.apicurio.datamodels.openapi.models.OasDocument, io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasDocument} document
     * @param {OasSchema} definition
     */
    addDefinition(document : OasDocument, definition : OasSchema) {
        let doc30 : Oas30Document = <Oas30Document>document;
        doc30.components.addSchemaDefinition(this._newDefinitionName, <Oas30SchemaDefinition>definition);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#removeDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    removeDefinition(document : OasDocument) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this._nullComponents) {
            doc30.components = null;
        } else {
            doc30.components.removeSchemaDefinition(this._newDefinitionName);
        }
    }
}
AddSchemaDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand_30";
AddSchemaDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




